import { Component, Host, h, Prop, Event } from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

import { Choice } from "../../../../utils/backend/reply-parsed";

@Component({
    tag: "c-dropdown",
    styleUrl: "c-dropdown.scss",
})
export class CDropdown {
    defaultText =
        "Bitte wählen Sie die Leistung, für die Sie sich interessieren aus der Liste aus:";
    defaultPlaceholder = "--- bitte auswählen ---";
    @Prop() text?: string = this.defaultText;
    @Prop() elements: Choice[] = [];
    @Prop() selectDisabled?: boolean = false;
    @Prop() selectPlaceholder?: string = this.defaultPlaceholder;
    @Prop() bubbleId: string;
    @Prop() withFeedback?: boolean;
    @Event() dropdownOptionSelected: EventEmitter<Choice>;

    handleOptionSelected(event) {
        const payload = event.target.value;
        const selectedChoice = this.elements.find(
            (el) => el.payload === payload
        );

        this.dropdownOptionSelected.emit(selectedChoice);
    }

    getSelectClass(): string {
        let style = "italic-placeholder";
        if (this.selectDisabled) {
            style = "disabled";
            if (this.selectPlaceholder === this.defaultPlaceholder) {
                style = "disabled italic-placeholder";
            }
        }
        return style;
    }

    render() {
        return (
            <Host
                class={
                    this.withFeedback ? "bubble-container-with-feedback" : ""
                }
            >
                <section
                    id={this.bubbleId}
                    class={this.withFeedback ? "bubble-with-feedback" : ""}
                >
                    <label
                        htmlFor="c-auswahl-liste"
                        class="introductory-text"
                    >{this.text}</label>
                    <select
                        id="c-auswahl-liste"
                        disabled={this.selectDisabled}
                        class={this.getSelectClass()}
                        name="topics-dropdown"
                        onInput={(event) => this.handleOptionSelected(event)}
                    >
                        <option
                            data-default
                            value=""
                            disabled
                            selected
                            hidden
                            id="default-option"
                        >
                            {this.selectPlaceholder}
                        </option>
                        {this.elements.map((choice) => (
                            <option
                                key={choice.title}
                                value={choice.payload}
                                innerHTML={choice.title}
                            ></option>
                        ))}
                    </select>
                </section>
                {this.withFeedback && (
                    <c-feedback bubbleId={this.bubbleId}></c-feedback>
                )}
            </Host>
        );
    }
}
